module.exports = __webpack_public_path__ + "img/partner_5.57482ade.jpg";